var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"icon":""}},[_c('v-badge',{attrs:{"value":_vm.messages.length,"content":_vm.messages.length,"overlap":"","color":"red"}},[_c('v-icon',[_vm._v("mdi-bell")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }